import { YYYY_MM_DD_FORMAT } from "constants"
import { DATE_FORMAT } from "constants"
import dayjs from "dayjs"
import { dateTimeFunction } from "utils/date"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"
const meetingListTransformHelper = (response, args) => {
  let currentDate = dateTimeFunction({ date: response?.data[0]?.scheduledStartTime, format: YYYY_MM_DD_FORMAT })
  const meetingList = response?.data.map((e, index, array) => {
    let privileges = createPrivilegeObject(e.privileges)
    const result = {
      ...e,
      privileges,
      originalArgs: { ...args },
      today:
        dateTimeFunction({ date: e?.scheduledStartTime, format: YYYY_MM_DD_FORMAT }) ===
        dateTimeFunction({ date: dayjs(), format: YYYY_MM_DD_FORMAT }),
    }

    if (index == 0) {
      result.addNewDate = currentDate
    }

    if (index != 0) {
      const checkDate = dateTimeFunction({ date: array[index]?.scheduledStartTime, format: YYYY_MM_DD_FORMAT })

      if (checkDate !== currentDate) {
        result.addNewDate = checkDate
        currentDate = checkDate
      }
    }
    return result
  })

  let meetingHash = { [args.pageIndex]: meetingList }

  return meetingHash
}
export default meetingListTransformHelper
